import { Action, handleActions } from 'redux-actions'
import {
  ActivityProgress,
  CompanyCountriesDto,
  CompanyId,
  DivisionDto,
  DivisionRow,
  PeriodType,
  UserCompanyId,
} from '../../../services/api.types'
import {
  getUserCompanyCountriesSuccess,
  getCompanyDivisionsSuccess,
  joinCompanyLoading,
  joinCompanySuccess,
  setJoinedCompanyId,
  updateUserCompanyProfileLoading,
  updateUserCompanyProfileSuccess,
  updateUserCompanyProfileFail,
  getCompanyDivisionsFail,
  getCompanyDivisions,
  setDivisionsLoading,
  changePasswordFail,
  //getUserActivitySuccess,
} from './SettingsActions'
import { getCompanyTeams, getDivisionsSuccess } from '../../TeamManagement/store/TeamManagementActions'

export class State {
  activity: ActivityProgress = {
    actualMaxHeartRate: 0,
    calculatedMaxHeartRate: 0,
    caloriesGoal: 0,
    caloriesPercentage: 0,
    caloriesProjectedPercentage: 0,
    caloriesTotal: 0,
    divisionName: '',
    country: '',
    lastSync: 0,
    email: '',
    endDate: 0,
    firstName: '',
    goalId: '',
    intensiveMinutesGoal: 0,
    intensiveMinutesPercentage: 0,
    intensiveMinutesProjectedPercentage: 0,
    intensiveMinutesTotal: 0,
    lastName: '',
    ofPeriodPassedPercentage: 0,
    startDate: 0,
    stepsGoal: 0,
    stepsPercentage: 0,
    stepsProjectedPercentage: 0,
    stepsTotal: 0,
    totalPercentage: 0,
    totalProjectedPercentage: 0,
    userId: '',
    period: PeriodType.MONTH,
    persistenceGoal: 0,
    persistencePercentage: 0,
    persistenceTotal: 0,
  }

  countries: CompanyCountriesDto[] = []

  // Deprecated
  divisions: DivisionDto[] = []

  //companyDivisions: { [companyId: string]: { [categoryId: string]: DivisionDto[] } } = {}
  companyDivisions: DivisionDto[] = []
  divisionsLoading = false

  joinCompanyLoading: boolean = false

  joinedCompanyId: UserCompanyId | null = null

  userCompanyProfileLoading: boolean = false

  // Increments each time changePassword fails. The Settings component watches this
  // to keep the form open and refocus the old-password input on error.
  changePasswordFailCount: number = 0

  // Field-specific error to render inline (currently only the old-password mismatch).
  changePasswordOldPasswordError: string = ''
}

export const settings = handleActions<State, any>(
  {
    /*[String(getUserActivitySuccess)]: (state: State, { payload }: any): State => ({
      ...state,
      activity: payload,
    }),*/
    [String(getUserCompanyCountriesSuccess)]: (
      state: State,
      { payload = [] }: Action<CompanyCountriesDto[]>,
    ): State => {
      // Merge by companyId so refetching for one managed company doesn't wipe out
      // the user's own-company entries (superadmin flow switches target company).
      const incomingIds = new Set(payload.map((c) => c.companyId))
      const preserved = state.countries.filter((c) => !incomingIds.has(c.companyId))
      return {
        ...state,
        countries: [...preserved, ...payload],
      }
    },
    /*[String(getCompanyDivisionsSuccess)]: (state: State, { payload = [] }: Action<DivisionDto[]>): State => ({
      ...state,
      divisions: payload,
    }),*/
    [String(setDivisionsLoading)]: (state: State): State => {
      console.log('setDivisionsLoading')
      return {
        ...state,
        divisionsLoading: true,
      }
    },
    [String(getCompanyDivisionsFail)]: (state: State): State => ({
      ...state,
      divisionsLoading: false,
    }),
    [String(getCompanyDivisionsSuccess)]: (
      state: State,
      { payload: companyDivisions = [] }: Action<DivisionDto[]>,
    ): State => {
      return {
        ...state,
        companyDivisions,
        divisionsLoading: false,
      }
      /*// First categorize by companyId, then by categoryId
      const companyDivisions = divisions.reduce(
        (acc, division) => {
          // Initialize companyId if it doesn't exist
          if (!acc[division.companyId]) {
            acc[division.companyId] = {}
          }
          // Initialize categoryId within the company if it doesn't exist
          if (!acc[division.companyId][division.categoryId]) {
            acc[division.companyId][division.categoryId] = []
          }
          // Add the division to the appropriate category within the company
          acc[division.companyId][division.categoryId].push(division)
          return acc
        },
        {} as Record<string, Record<string, DivisionDto[]>>,
      )

      return {
        ...state,
        companyDivisions,
      }*/
    },
    [String(joinCompanyLoading)]: (state: State, { payload }: Action<boolean>): State => ({
      ...state,
      joinCompanyLoading: payload,
    }),
    [String(joinCompanySuccess)]: (state: State): State => ({
      ...state,
      joinCompanyLoading: false,
    }),
    [String(setJoinedCompanyId)]: (state: State, { payload }: Action<UserCompanyId | null>): State => ({
      ...state,
      joinedCompanyId: payload,
    }),
    [String(updateUserCompanyProfileLoading)]: (state: State, { payload }: Action<boolean>): State => ({
      ...state,
      userCompanyProfileLoading: payload,
    }),
    [String(updateUserCompanyProfileSuccess)]: (state: State): State => ({
      ...state,
      userCompanyProfileLoading: false,
    }),
    [String(updateUserCompanyProfileFail)]: (state: State): State => ({
      ...state,
      userCompanyProfileLoading: false,
    }),
    [String(changePasswordFail)]: (state: State, { payload }: Action<{ oldPasswordError?: string }>): State => ({
      ...state,
      changePasswordFailCount: state.changePasswordFailCount + 1,
      changePasswordOldPasswordError: payload?.oldPasswordError || '',
    }),
  },
  new State(),
)

export { State as SettingsState }
